import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AnswerModuleResponse } from '../../shared/models/answer-module-response';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  constructor(private router: Router) {}

  redirectToView(response: AnswerModuleResponse) {
    if (response.view.type === 'SURVEY_PAGE') {
      this.router.navigate(
        [`${response.responseId}/view/${response.stateId}`],
        { state: { data: response } },
      );
    } else if (response.view.type === 'INFORMATION') {
      this.router.navigate([`${response.responseId}/information`], {
        state: { data: response },
      });
    } else if (response.view.type === 'CHOOSE_LANGUAGE') {
      this.router.navigate([`${response.responseId}/choose-language`], {
        state: { data: response },
      });
    } else if (response.view.type === 'GDPR_CONSENT') {
      this.router.navigate([`${response.responseId}/gdpr`], {
        state: { data: response },
      });
    } else if (response.view.type === 'QUEST_PASSWORD') {
      this.router.navigate([`${response.responseId}/password`], {
        state: { data: response },
      });
    } else if (response.view.type === 'START_OVER') {
      this.router.navigate([`${response.responseId}/start-over`], {
        state: { data: response },
      });
    } else if (response.view.type === 'GOTO_PAGE') {
      this.router.navigate([`${response.responseId}/goto-page`], {
        state: { data: response },
      });
    }
  }

  redirectToErrorPage(code: number) {
    this.router.navigate([`error-page/${code}`], {
      state: { data: code },
    });
  }
}
